import { Collapse, Paper } from '@mui/material';
import { FC, useState } from 'react';
import { SidebarContent } from './SidebarContent';

interface Props {
  collapsed: boolean;
}

export const SidebarCollapsable: FC<Props> = ({ collapsed }) => {
  const [afterAnimationCollapsed, setAfterAnimationCollapsed] = useState(collapsed);

  const fullCollapsed = afterAnimationCollapsed && collapsed;

  return (
    <Paper
      sx={{
        scrollbarWidth: 'thin',
        scrollbarGutter: collapsed ? 'unset' : 'stable',
        borderRight: 1,
        borderColor: 'divider',
        height: '100%',
        overflowY: collapsed ? 'auto' : 'auto',
        overflowX: 'hidden',
        borderRadius: 0,
        borderTop: 0,
      }}
    >
      <Collapse
        in={!collapsed}
        orientation="horizontal"
        collapsedSize={60}
        addEndListener={() => {
          setAfterAnimationCollapsed(collapsed);
        }}
      >
        <SidebarContent collapsed={fullCollapsed} />
      </Collapse>
    </Paper>
  );
};
